<finxone-web-frontend-toggle-switch
  [widgetConfigData]="widgetConfigData"
  [contentStyle]="contentStyle"
  [iconStyle]="iconStyle"
  [textContentStyle]="textContentStyle"
  [checkedValue]="currentCardDetail?.status === CardStatusType.FROZEN"
  [showToggleSwitch]="showToggleSwitch"
  (valueChangeEmit)="onToggleSwitchChange($event)"
  [isDisabled]="isDisabled"
></finxone-web-frontend-toggle-switch>
